module.exports = __webpack_public_path__ + "img/cave48.a43ee04a.jpg";